import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import OkapiThreeWheelSales from './BajajMaximaC';
import './App.css';
import Engine  from '../src/Pages/EngineSpecs';
import Motercycle from "../src/Pages/Motercycle";

function App() {
  return (
    <div className="App">

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/enginer" element={<Engine  />} />
          <Route path="/Motercycle" element={<Motercycle  />} />
          {/* Add more routes here as needed */}
        </Routes>
    </div>
  );
}

export default App;
